import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";

const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) {
          setStatus("error");
          return;
        }
      } catch {
        setStatus("error");
        return;
      }
      attempts += 1;
      if (attempts > 10) {
        setStatus("pending");
        return;
      }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center px-6 text-center">
      <div className="max-w-md w-full bg-[#121212] border border-white/10 rounded-2xl p-10" data-testid="payment-success-page">
        {status === "checking" && (
          <>
            <Loader2 className="animate-spin text-[#FFF200] mx-auto mb-5" size={48} />
            <h1 className="font-display text-2xl font-bold text-white">Verifica pagamento...</h1>
            <p className="text-white/50 mt-2">Attendere qualche istante.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="text-[#FFF200] mx-auto mb-5" size={56} />
            <h1 className="font-display text-3xl font-bold text-white">Prenotazione confermata!</h1>
            <p className="text-white/60 mt-3">
              Grazie per aver scelto Cardillo Viaggi. Riceverai i dettagli a breve
              {info?.event_title ? ` per "${info.event_title}"` : ""}.
            </p>
            {info?.amount != null && (
              <p className="text-[#FFF200] font-display text-xl font-bold mt-4">
                Importo: €{Number(info.amount).toFixed(2)}
              </p>
            )}
          </>
        )}
        {status === "pending" && (
          <>
            <Loader2 className="text-[#FFF200] mx-auto mb-5" size={48} />
            <h1 className="font-display text-2xl font-bold text-white">Pagamento in elaborazione</h1>
            <p className="text-white/50 mt-2">Ti aggiorneremo via email non appena confermato.</p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="text-red-400 mx-auto mb-5" size={56} />
            <h1 className="font-display text-2xl font-bold text-white">Qualcosa è andato storto</h1>
            <p className="text-white/50 mt-2">Non è stato possibile verificare il pagamento.</p>
          </>
        )}
        <Link
          to="/"
          data-testid="success-home-link"
          className="inline-block mt-8 bg-[#FFF200] text-black font-semibold px-7 py-3 rounded-full hover:bg-[#FFF200]/90 transition-colors"
        >
          Torna alla home
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;
